/**
 *
 * Utility to set all the providers on a provider factory
 *
 * @param providerFactory
 * @param props
 * @param extensionProvider
 * @param quickInsertProvider
 */
export default function handleProviders(providerFactory, _ref, extensionProvider, quickInsertProvider) {
  var emojiProvider = _ref.emojiProvider,
    mentionProvider = _ref.mentionProvider,
    taskDecisionProvider = _ref.taskDecisionProvider,
    contextIdentifierProvider = _ref.contextIdentifierProvider,
    collabEditProvider = _ref.collabEditProvider,
    activityProvider = _ref.activityProvider,
    presenceProvider = _ref.presenceProvider,
    macroProvider = _ref.macroProvider,
    imageUploadProvider = _ref.imageUploadProvider,
    mediaProvider = _ref.mediaProvider,
    autoformattingProvider = _ref.autoformattingProvider,
    searchProvider = _ref.searchProvider,
    cardProvider = _ref.cardProvider;
  providerFactory.setProvider('emojiProvider', emojiProvider);
  providerFactory.setProvider('mentionProvider', mentionProvider);
  providerFactory.setProvider('taskDecisionProvider', taskDecisionProvider);
  providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
  providerFactory.setProvider('mediaProvider', mediaProvider);
  providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
  providerFactory.setProvider('collabEditProvider', collabEditProvider);
  providerFactory.setProvider('activityProvider', activityProvider);
  providerFactory.setProvider('searchProvider', searchProvider);
  providerFactory.setProvider('presenceProvider', presenceProvider);
  providerFactory.setProvider('macroProvider', macroProvider);
  if (cardProvider) {
    providerFactory.setProvider('cardProvider', cardProvider);
  }
  providerFactory.setProvider('autoformattingProvider', autoformattingProvider);
  if (extensionProvider) {
    providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
  }
  if (quickInsertProvider) {
    providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
  }
}